import styled from "styled-components";
import { ButtonSettings } from "../../../services/visualLibraryService";

export const ButtonStyled = styled(ButtonSettings)`
font-size: 1.3rem;
& span{
  font-size: 1.3rem;
}
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    margin-top: ${props.theme.spacing.medium};
    width: 35rem;
  `}
`;
